
"use client";

import { db } from "../../firebase";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import useSWRSubscription from "swr/subscription";

export function usePosts(collectionName = "posts") {
  const { data, error } = useSWRSubscription(
    [collectionName],
    ([path], { next }) => {
      const ref = collection(db, path);

      const unsub = onSnapshot(
        ref,
        (snaps) => {
          next(
            null,
            snaps.docs.map((v) => v.data())
          );
        },
        (error) => {
          next(error?.message);
        }
      );
      return () => unsub();
    }
  );
  return {
    data,
    error,
    isLoading: data === undefined ? true : false,
  };
}

export const getPost = async (id, collectionName = "posts") => {
  return await getDoc(doc(db, collectionName, id));
};